import { take, call, put } from 'redux-saga/effects';
import Auth from '@defi/core-auth';
import Url from '../utils/url';
import { LOGOUT } from '../actions/constants';
import { PATH_LOGIN_FULL, PATH_ROOT_DEFI } from "../paths";
import { push } from 'connected-react-router';

export function logout() {

  // Similar to above, we try to log out by calling the `logout` function in the
  // `auth` module. If we get an error, we send an appropiate action. If we don't,
  // we return the response.
  return Auth.logoutCleanup();
}

/**
 * Log out saga
 * This is basically the same as the `if (winner.logout)` of above, just written
 * as a saga that is always listening to `LOGOUT` actions
 */
export function* logoutFlow() {
  while (true) {
    yield take(LOGOUT);
    try {
      yield call(logout);
    } catch (error) {
      yield call(forwardToLogin);
    }

    yield call(forwardToLogin);
  }

  function* forwardToLogin() {
    if (localStorage.SsoLoggedIn !== "true") {

      var pathRoot = localStorage.DefiUserLogin === "true" ? PATH_ROOT_DEFI : PATH_LOGIN_FULL;

      let redirectUrl = Url.getRedirectParameter();
      if (redirectUrl !== null) {
        if (redirectUrl.substring(0, 1) !== '/') {
          redirectUrl = '' + redirectUrl;
        }
        if (redirectUrl.indexOf('ReturnUrl=') > -1) {
          let split = redirectUrl.split('ReturnUrl=');
          yield put(push(pathRoot + '?ReturnUrl=' + split[1]))
        }
        else {
          yield put(push(pathRoot + '?ReturnUrl=' + redirectUrl))
        }
      }
      else {
        yield put(push(pathRoot))
      }
    }
  }
}